import { formatIndianCurrency, formatNumberWithCommas } from "@/app/utils/helper";

type InvestmentDetails = {
    units: number;
    currentMTM: number;
    amountInvested: number;
    profitInAmount: number;
    profitInPerc: number;
};

type PortfolioProps = {
    data: InvestmentDetails;
};

export const UserPortfolio: React.FC<PortfolioProps> = ({ data }) => {
    return (
        <div className="flex flex-col gap-6 bg-white p-s14 sm:container sm:py-0 sm:pb-10 sm:pt-10 md:flex-col">
            <h3 className="text-3xl font-semibold leading-[130%] tracking-[-0.24px] text-neutral-900">
                Your Investment
            </h3>
            <div className="grid grid-cols-2 gap-6 md:flex md:grid-cols-4 md:items-center md:gap-6">
                <div className="md:min-w-[262px]">
                    <h4 className="text-md font-regular leading-[160%] text-neutral-300">
                        Current value
                    </h4>
                    <p className="flex items-center gap-3 text-3xl font-semibold text-neutral-900">
                        {formatIndianCurrency(data?.currentMTM ?? 0)}{" "}
                        <span className={`text-md font-regular leading-[160%] ${data?.profitInPerc < 0 ? "text-red-500" : "text-success-700"}`}>
                            {`${data?.profitInPerc > 0 ? "+" : data?.profitInPerc === 0 ? "" : ""}${data?.profitInPerc ?? 0}%`}
                        </span>
                    </p>
                </div>

                <div className="text-right md:min-w-[166px] md:text-left">
                    <h4 className="text-md font-regular leading-[160%] text-neutral-300">
                        Invested
                    </h4>
                    <p className="text-lg font-medium leading-[164%] tracking-[-0.18px]">
                        {formatIndianCurrency(data?.amountInvested ?? 0)}
                    </p>
                </div>

                <div className="md:min-w-[154px]">
                    <h4 className="text-md font-regular leading-[160%] text-neutral-300">Units</h4>
                    <p className="text-lg font-medium leading-[164%] tracking-[-0.18px]">
                        {formatNumberWithCommas(data?.units ?? 0)}
                    </p>
                </div>

                <div className="text-right md:min-w-[110px] md:text-left">
                    <h4 className="text-md font-regular leading-[160%] text-neutral-300">P&L</h4>
                    <p
                        className={`text-lg font-medium leading-[164%] tracking-[-0.18px] ${data?.profitInAmount < 0 ? "text-warning-500" : "text-success-700"}`}
                    >
                        {formatIndianCurrency(data?.profitInAmount ?? 0)}
                    </p>
                </div>
            </div>
        </div>
    );
};
